import { EnvironmentConfig } from './environment.model';

export const environment: EnvironmentConfig = {
  production: false,
  apiBaseUrl: 'https://staginggateway.enwage.com/employee-portal-be/',
  identityApiUrl: 'https://stagingssoapi.9ostech.com/',
  ssoLoginUrl: 'https://stagingsso.9ostech.com/?logout=true',
  frontEndUrl: 'https://stagingemployeeportal.enwage.com/',
  zayzoonWidgetUrl: 'https://staging.zayzoon.xyz',
};

export class Environment {
  constructor() {}

  getApiConnection(): string {
    return environment.apiBaseUrl;
  }

  getIdentityServerConnection(): string {
    return environment.identityApiUrl;
  }

  getSSOLoginConnection(): string {
    return environment.ssoLoginUrl;
  }

  getFrontEndUrl(): string {
    return environment.frontEndUrl;
  }
}
